import React, { useState } from "react";
import DropdownC from "../../Dropdown";
import Icon from "../../Icon";
import IconButton from "../../IconButton";
import InputField from "../../InputField";

export default function MobilePhoneForm({
  formField,
  onChange,
  phoneValidators,
  onBackPhoneClick,
  options,
  onChangeDropdown,
  buttonClicked,
  countryCode,
  toSecond,
  callback,
}) {
  const [toFourth, setFourth] = useState(false);

  return (
    <div
      className={`flex flex-col h-screen items-center space-y-6 mt-8 px-8 ${
        toSecond && "duration-200 transform -translate-x-full ease-out"
      }`}
    >
      <img
        src={
          process.env.NEXT_PUBLIC_THEME === "LT"
            ? "/Images/icon-semitruck.webp"
            : "/Images/flexport/semi-truck.webp"
        }
        width={130}
      />
      <h3 className=" mt-3 font-hkBold text-lg text-inputColor">
        Mobile Number
      </h3>
      <h3 className=" font-hkMedium text-lg text-center text-gray6 opacity-80">
        {`Let’s keep your account secure. Enter your mobile number to enable 2-step verification.`}
      </h3>
      <div className={`flex flex-row space-x-1 px-4 mt-2`}>
        <DropdownC
          placeholder="Code"
          value={countryCode}
          width={"w-20"}
          options={options}
          onChange={onChangeDropdown}
        />
        <InputField
          width={"w-11/12"}
          icon={true}
          iconName={"icon-phone"}
          placeholder={"123 123 1234"}
          height={"h-14"}
          name={"phone"}
          value={formField.value}
          error={formField.error}
          onInputChange={onChange}
        />
      </div>

      <div className=" flex flex-row items-center justify-center space-x-2 w-full absolute bottom-footerMobileM px-8">
        <Icon name="icon-backInactive" onClick={onBackPhoneClick} />

        <IconButton
          title={"CONTINUE"}
          onButtonClick={async () => {
            let test = await phoneValidators();
            if (!test) {
              buttonClicked();
            }
          }}
          width="w-full"
          disabled={formField.disabled}
          height="h-14"
        />
      </div>
    </div>
  );
}
